import React, { Component } from "react";

class AppMobilePage extends Component {
  render() {
    return (
      <div>
        <iframe
          title="linkAppMobile"
          style={{ width: "100%", height: "100vh" }}
          src="https://testarea.beeweeb.com/teamsystem/"
        />
      </div>
    );
  }
}

export default AppMobilePage;